import { assert } from '@ember/debug';
import Service from '@ember/service';

import { clearToastQueue } from '@repo/design-system-kit/components/toast/provider/toast-queue';
import { showToast } from '@repo/design-system-kit/components/toast/provider/use-toast';

const TOAST_TIMEOUT_MS = 5000;

export default class ToastFlashMessagesService extends Service {
  toastInfo(message) {
    assert('A flashMessage must have a message', message);

    return showToast({ type: 'info', text: message }, { timeout: TOAST_TIMEOUT_MS });
  }

  toastSuccess(message) {
    assert('A flashMessage must have a message', message);

    return showToast({ type: 'success', text: message }, { timeout: TOAST_TIMEOUT_MS });
  }

  toastError(message) {
    assert('A flashMessage must have a message', message);

    return showToast({ type: 'error', text: message }, { timeout: TOAST_TIMEOUT_MS });
  }

  clearToastMessages() {
    clearToastQueue();
  }
}
